import React from "react";
import { functions } from "../lib/appwrite";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";


const SuccessPage = () => {
  const [invoicePdf, setInvoicePdf] = useState(null);
  const [searchParams] = useSearchParams();

  const sessionId = searchParams.get("session_id");

  console.log("sessionId", sessionId);

  useEffect(() => {
    console.log("sessionId", sessionId);
    const fetchInvoicePdf = async () => {
      const response = await functions.createExecution(
        "downloadInvoice",
        JSON.stringify({ sessionId: sessionId })
      );  
      const invoicePdf = JSON.parse(response.responseBody).invoicePdf;
      setInvoicePdf(invoicePdf);
    };

    fetchInvoicePdf();
  }, [sessionId]); 

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 font-display">
      <div className="bg-white p-8 md:p-12 rounded-xl shadow-xl text-center relative m-4 md:m-0 max-w-lg">
        <div className="flex items-center justify-center w-16 h-16 bg-[#27D152] mx-auto rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="#FFFFFF"
            className="w-8 h-8"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="5"
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="mt-6 text-2xl font-bold text-gray-900">Payment Successful!</h1>
        <p className="mt-2 text-lg font-medium text-gray-700">
          Thank you for your purchase. Your payment has been processed.
        </p>

        <div className="mt-8 space-y-4">
          {/* Download Invoice Button */}
          <button id="download-invoice"
            className="w-3/4 mb-4 bg-blue-500 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-colors duration-200"
            onClick={async () => {
              const response = await functions.createExecution(
                "downloadInvoice",
                JSON.stringify({ sessionId: sessionId })
              );
              const invoicePdf = JSON.parse(response.responseBody).invoicePdf;
              window.open(invoicePdf, "_blank");
            }}
          >
            Download Invoice
          </button>

          <p className="mt-4 text-sm text-gray-600">
            A link to your <strong>AI Readiness & Digital Maturity Assessment Index</strong> has been sent to your registered email.
          </p>

          <p className="text-sm font-medium text-gray-700 mt-4">
            <strong>Or</strong>
            <p className="text-sm text-gray-600 mt-4">To get started right away,{" "}<button id="redirecting-to-test" className=" text-green-600 font-bold text-lg " onClick={() => window.open("https://assessment.ai-readiness.app/")}>click here</button>
            {" "}to access your assessment</p>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
